import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  margin: 20px 30px;
  background-color: ${colors.grayExtraLight};
  overflow-y: auto;

  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  @media (max-height: 1080px) {
    height: 400px;
    flex: 1;
  }
`

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 20px 30px;
  background-color: ${colors.grayExtraLight};
  overflow-y: auto;

  border-radius: 4px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0px 32px 12px;
  background-color: ${colors.white};

  @media (max-height: 1080px) {
    height: auto;
    flex: 1;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 80px;
  background-color: ${colors.white};
  padding: 24px 30px;
  align-self: flex-start;
  overflow: hidden;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 16px;
  font-weight: 700;
  padding: 30px 0px;
  color: ${colors.blue};
`
